import React from 'react';
import { COLORS } from '../../../constant/colors';

const Divider = () => <hr style={{ borderTop: 1, width: '100%', borderColor: COLORS.borderLightGrey, margin: 0 }} />;

export default Divider;
